import { FCWithChildren } from 'global'
import { Route, Switch } from 'react-router'
import NoPageError from '../NoPageError'

// TODO: Add in handling to useRouterParams and send down routerPath to child components
const CustomSwitch: FCWithChildren = ({ children }) => (
  <Switch>
    {children}
    <Route component={NoPageError} />
  </Switch>
)

export default CustomSwitch
